import ZIcon from './ZIcon.vue'

export default ZIcon
